import { useAsset } from '../../../../hooks/stateful/useAsset';
import useSelectedIndex from '../../../../hooks/stateful/useSelectedIndex';
import useDownloadAgreementsData from '../../../api/download/useDownloadAgreementsData';
import {
  getRfSubscriptionAgreement,
  RF_SUBSCRIPTION_AGREEMENT_TYPE,
} from '../../../rfSubscriptionPredicates';

const useDownloadsRemaining = (): { count: number } | null => {
  const { asset } = useAsset() as { asset: { id: string } | null };
  const { selectedOption } = useSelectedIndex();
  const downloadAgreements = useDownloadAgreementsData(asset?.id);

  if (selectedOption?.type !== RF_SUBSCRIPTION_AGREEMENT_TYPE) return null;

  const rfAgreement = getRfSubscriptionAgreement(downloadAgreements);
  if (!rfAgreement?.agreementDetails) return null;
  if (rfAgreement.agreementDetails.hasUnlimitedDownload) return null;

  const { downloadCount, downloadCapacity } = rfAgreement.agreementDetails;
  return { count: Math.max(0, downloadCapacity - downloadCount) };
};

export default useDownloadsRemaining;
